module.exports = ".expansion-footer {\n  justify-content: flex-start !important; }\n"